export default __webpack_public_path__ + "static/media/beep_error.fc9e6561.wav";